import { FC } from 'react'

import { Button } from '@/components/ui'

import Cancel from '@/assets/icons/cancel-3.svg'
import CircleDashed from '@/assets/icons/circle-dashed.svg'
import Copy from '@/assets/icons/copy.svg'

interface IProps {
	isSelectMode: boolean
	hasFolders: boolean
	hasSelectedFolders: boolean
	isImporting: boolean
	onSelectMode: () => void
	onCancelSelection: () => void
	onImportSelected: () => void
}

const SharedHighlightControls: FC<IProps> = ({
	isSelectMode,
	hasFolders,
	hasSelectedFolders,
	isImporting,
	onSelectMode,
	onCancelSelection,
	onImportSelected
}) => {
	return (
		<div className='flex justify-between items-center gap-2.5 py-2.5 mx-3'>
			{isSelectMode ? (
				<>
					<Button
						className='w-full py-[9px] px-3 !text-neutral-900 bg-neutral-200 rounded-[8px]'
						classNameText='flex gap-2 items-center'
						onClick={onCancelSelection}
					>
						<Cancel />
						<span>Cancel</span>
					</Button>

					<Button
						disabled={!hasSelectedFolders || isImporting}
						className='p-2 bg-neutral-200 rounded-full'
						onClick={onImportSelected}
					>
						<Copy className='text-neutral-900 w-4 h-4' />
					</Button>
				</>
			) : (
				<Button
					className='w-full py-[9px] px-3 !text-neutral-900 bg-neutral-200 rounded-[8px]'
					classNameText='flex gap-2 items-center'
					disabled={!hasFolders}
					onClick={onSelectMode}
				>
					<CircleDashed />
					<span>Select</span>
				</Button>
			)}
		</div>
	)
}

export default SharedHighlightControls
